import DealerPointExpiringListPanel from "./dealerPointExpiringListPanel.container"

export default DealerPointExpiringListPanel
